export default "__VITE_ASSET__b5d04d47__"